import { getCurrentVAccount } from './Session.js';

export const IsValidDomain = (expectedDomain, profile, session) => {
    const entity = getCurrentVAccount(profile, session);
    return (expectedDomain === entity?.companyDomain);
};
